export const SAVED_COURSES_META_REQUEST = 'SAVED_COURSES_META_REQUEST'
export const SAVED_COURSES_META_SUCCESS = 'SAVED_COURSES_META_SUCCESS'
export const SAVED_COURSES_META_FAILURE = 'SAVED_COURSES_META_FAILURE'
